import { useQuery } from "@apollo/client";
import { FirmaDto } from "../../../../../interfaces/schema";
import { AccordionCard } from "../../../../accordion/Accordion";
import FirmaSanktioner from "./FirmaSanktioner";
import Spinner from "../../../../spinner/Spinner";
import { GET_FIRMA_DISCIPLINAERT_BY_ID_QUERY } from "../../../../../api/firma/queries";
import { transformQueryDataPerioder } from "../../../../../util/apollo";
import { useState } from "react";

export default function Disciplinaert({ firma }: { firma: FirmaDto }) {
  const { id } = firma;
  const [data, setData] = useState<
    | {
        firma: FirmaDto;
      }
    | undefined
  >(undefined);
  const { loading, error, refetch } = useQuery<{ firma: FirmaDto }>(
    GET_FIRMA_DISCIPLINAERT_BY_ID_QUERY(),
    {
      variables: { id },
      notifyOnNetworkStatusChange: true,
      onCompleted: (d) => {
        const transformed = transformQueryDataPerioder(d);
        setData(transformed);
      },
    },
  );
  if (loading) return <Spinner />;
  if (error) return <div>noget gik galt 😔</div>;
  if (!data || !data.firma) return null;
  return (
    <div className="container">
      <AccordionCard
        title="Sanktioner"
        value="sanktioner"
        defaultValue={["sanktioner"]}
        localstorageKey="firma-id-stamoplysninger-accordion-value"
        isEmpty={
          !data.firma.firmaSanktion || data.firma.firmaSanktion.length === 0
        }
      >
        <FirmaSanktioner
          firma={firma}
          invalidateData={refetch}
          firmaSanktion={data.firma.firmaSanktion}
        />
      </AccordionCard>
    </div>
  );
}
